import { httpRequest } from "../../http";
import { LaunchAdSerializer } from "../../../models/serializers/launchAdSerializer.ts";

export type EngagementAdStatus =
  | "TODO" | "IN_PROGRESS" | "APPROVED" | "IN_REVIEW" | "CHANGES_REQUESTED"
  /** Rejected and not to be offered to this client again (MPN-1612). */
  | "DO_NOT_USE";

export class CommandUpdateEngagementAdStatus {
  /**
   * PATCH /api/v1/engagements/:engagementId/ads/:adId/
   * Body: { status: "TODO" | "IN_PROGRESS" | "DONE" }
   *
   * Returns updated ad (if API responds with 200) or null (if 204 No Content).
   */
  async run(
    engagementId: number,
    adId: number,
    status: EngagementAdStatus
  ) {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/ads/${adId}/`;
    const payload = { status };

    const raw = await httpRequest<any | null>(url, {
      method: "PATCH",
      body: payload,
    });

    // Handle both 200 (object) and 204 (no content)
    if (raw && typeof raw === "object") {
      return new LaunchAdSerializer().deserialize(raw);
    }
    return null;
  }
}
